import React from "react";

import Span from "../Span";
import * as Styled from "./styles";

interface ILegend {
  color: string;
  caption: string;
}

interface IAttributeColorLegendProps {
  legends: ILegend[];
}

const AttributeColorLegend: React.FC<IAttributeColorLegendProps> = ({ legends }) => (
  <Styled.Container>
    {legends.map((item) => (
      <Styled.Legend key={item.caption}>
        <Styled.Color legendColor={item.color} />
        <Styled.Text>
          <Span>{item.caption}</Span>
        </Styled.Text>
      </Styled.Legend>
    ))}
  </Styled.Container>
);

export default AttributeColorLegend;